export enum TabContainerStickyClassActions {
  add = 'add',
  remove = 'remove',
}

export enum WindowEvents {
  scroll = 'scroll',
  resize = 'resize',
}

export enum MouseKeys {
  mousedown = 'mousedown',
  mouseleave = 'mouseleave',
  mouseup = 'mouseup',
  mousemove = 'mousemove',
}

export enum ListenerType {
  window = 'window',
  tabContainer = 'tabContainer',
}

export enum ListenerAction {
  add = 'add',
  remove = 'remove',
}

export interface IListeners<T extends WindowEvents | MouseKeys> {
  key: T;
  func: (e: unknown) => unknown;
  type: ListenerType;
}

export interface ITabsData {
  tabs: any;
  tabsTitles: any;
  currentActiveTab: any;
  tabContainerRef: any;
  tabSectionsRef: any;
  tabWrapperRef: any;
}

export enum TabsState {
  base = 'base',
  sticky = 'sticky',
  stuck = 'stuck',
}
